const formatNumber = (number: number, options = {}) => {
    if (number === undefined || number === null) return '';

    const formatted = Intl.NumberFormat('en-US', options).format(number);

    return formatted;
};

export default formatNumber;
